import styled from 'styled-components';
import device from '../../mediaQueries';

const InputWrapper = styled.div`
  display: flex;
  width: 100%;
  position: relative;
  margin: ${({ margin }) => margin || null};
  justify-content: ${({ justifyContent }) => justifyContent || 'flex-start'};
  ${device.desktop`
    padding-bottom: ${({ paddingBottom }) => paddingBottom || '25px'}
  `}
  ${device.mobile`
  padding-bottom: ${({ paddingBottom }) => paddingBottom || '20px'}
  `}
`;

export default InputWrapper;
